import { CampaignQuickActions, CampaignTypes } from "../Enums/CampaignTypes";

export const crmLiteUpgradeMessage =
  "Contact your Account Director to upgrade to our Activate CRM - Initiate Tier";

/**
 * Allowed routes for CRM Lite clients. Add new routes here as CRM Lite features are added to each page.
 */
export const crmLiteAllowedRoutes = ["/", "/candidates", "/candidategroups", "/leadcapture"];

const campaignTypeActionLookup: Record<CampaignTypes, CampaignQuickActions[]> = {
  [CampaignTypes.Form]: [
    CampaignQuickActions.Edit,
    CampaignQuickActions.Duplicate,
    CampaignQuickActions.ViewGroup,
    CampaignQuickActions.EmbedScript,
    CampaignQuickActions.Delete,
    CampaignQuickActions.Export,
    CampaignQuickActions.Overwrite,
  ],
  [CampaignTypes.Event]: [CampaignQuickActions.ViewGroup],
  [CampaignTypes.JobAlerts]: [
    CampaignQuickActions.Edit,
    CampaignQuickActions.ViewGroup,
    CampaignQuickActions.EmbedScript,
    CampaignQuickActions.Export,
    CampaignQuickActions.Overwrite,
  ],
  [CampaignTypes.JobAlertsAndTalentNetwork]: [
    CampaignQuickActions.Edit,
    CampaignQuickActions.ViewGroup,
    CampaignQuickActions.EmbedScript,
    CampaignQuickActions.Export,
    CampaignQuickActions.Overwrite,
  ],
  [CampaignTypes.TalentNetwork]: [
    CampaignQuickActions.Edit,
    CampaignQuickActions.ViewGroup,
    CampaignQuickActions.EmbedScript,
    CampaignQuickActions.Export,
    CampaignQuickActions.Overwrite,
  ],
};

export const isActionAllowedByCampaignType = (campaignType: CampaignTypes, action: CampaignQuickActions) => {
  return campaignTypeActionLookup[campaignType]?.includes(action) ?? false;
};

export const getAllowedCampaignActions = (campaignType?: CampaignTypes) => {
  return !campaignType ? [] : (campaignTypeActionLookup[campaignType] ?? []);
};
